import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import { usePapaParse } from "react-papaparse";

import { Axis, Chart, Point, Tooltip } from "bizcharts";
import DownloadButton from "../Common/DownloadButton";
import "../../Style/CommoditiesMenu.scss";

const ScatterDotsChart = (props) => {
  const [data, setData] = useState([]);

  const csv = props.csv;
  const filter = props.filter;
  const { readString } = usePapaParse();

  const handleReadString = () => {
    readString(csv, {
      complete: (results, file) => {
        const filtered = results.data
          .filter((d) => d["Food Commodity"] === filter)
          .sort((a, b) => {
            return a["Pesticide"] < b["Pesticide"] ? 1 : -1;
          });
        setData(filtered);
      },
      download: true,
      header: true,
      dynamicTyping: true,
      error: (error, file) => {
        console.log("Error while parsing:", error, file);
      },
    });
  };

  useEffect(() => {
    handleReadString();
  }, [csv, filter]);

  const [canvas, setCanvas] = useState(undefined);

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
  useEffect(() => {
    function handleResize() {
      setIsMobile(window.innerWidth <= 900);
    }
    window.addEventListener("resize", handleResize);
    return (_) => {
      window.removeEventListener("resize", handleResize);
    };
  });
  console.log(data.length);
  return (
    <Box>
      {data.length > 0 && (
        <Box>
          <Box
            display="flex"
            justifyContent="space-between"
            className="box-scatterChart"
            alignItems="center"
          >
            <p
              className="titleChart"
              style={{
                fontFamily: "Roboto Condensed, sans-serif",
                marginBottom: ".5rem",
              }}
            >
              {props.title}
            </p>

            <Box className="downloadButton">
              <DownloadButton
                canvas={canvas}
                fileName={props.title}
                csv={data}
              />
            </Box>
          </Box>
          <Chart
            padding={isMobile ? [0, 20, 20, 218] : [0, 100, 20, 250]}
            height={
              data.length < 30 && data.length > 4
                ? data.length * 30
                : data.length <= 4
                ? data.length * 50
                : data.length > 31 && data.length < 45
                ? data.length * 15
                : data.length > 45 && data.length < 100
                ? data.length * 20
                : data.length * 4
            }
            data={data}
            forceFit
            autoFit
            interactions={["legend-highlight"]}
            onGetG2Instance={(chartInstance) => {
              setTimeout(() => {
                setCanvas(chartInstance.canvas);
              }, 1000);
            }}
          >
            <Point
              position="Percentage of the value of the Pesticides MRL*Pesticide"
              color="#22294D"
              shape="circle"
              tooltip={[
                "Percentage of the value of the Pesticides MRL*Pesticide",
                (percent, pecticide) => {
                  return {
                    pesticide: pecticide + ": " + percent + "%",
                  };
                },
              ]}
              style={{
                fillOpacity: 0.85,
              }}
            />
            <Axis
              name="Percentage of the value of the Pesticides MRL"
              label={{
                style: {
                  fontFamily: "Roboto Condensed, sans-serif",
                },
                formatter: (a) => {
                  return a + "%";
                },
              }}
            />
            <Axis
              name="Pesticide"
              label={{
                style: {
                  fontFamily: "Roboto Condensed, sans-serif",
                },
              }}
            />

            <Tooltip
              shared={true}
              showTitle={false}
              crosshairs={{ type: "y" }}
              itemTpl={
                '<li class="g2-tooltip-list-item" data-index={index} style="margin-bottom:4px;">' +
                '<span style="background-color:{color};" class="g2-tooltip-marker"></span>' +
                "<span >Pesticide: {pesticide}</span><br/>" +
                "</li>"
              }
              showCrosshairs
            />
          </Chart>
        </Box>
      )}
      {data.length === 0 && (
        <Box display="flex" justifyContent="center">
          <p
            style={{
              color: "#22294D",
              fontWeight: "700",
              maxWidth: "280px",
              textAlign: "center",
              fontSize: "15px",
              backgroundColor: "white",
              border: "1px solid #22294D",
              borderRadius: "10px",
              padding: "10px 10px 10px 10px",
            }}
          >
            No residues{" "}
            {props.residuesActive === 0 ? " above 100% " : " above 100% "} as
            percentage of MRL were reported to this food product.
          </p>
        </Box>
      )}
    </Box>
  );
};

export default ScatterDotsChart;
